export const CSS = {
  actionGroupEnd: "action-group--end",
  container: "container",
};

export const SLOTS = {
  expandTooltip: "expand-tooltip",
};
